import { render } from "./CheckboxRadioComponent.vue?vue&type=template&id=0b3fd3ed"
import script from "./CheckboxRadioComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxRadioComponent.vue?vue&type=script&lang=js"

import "./CheckboxRadioComponent.vue?vue&type=style&index=0&id=0b3fd3ed&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__